import EkgTable from './EkgTable'

export default EkgTable
